window.addEventListener('scroll', function() {
    const nav = document.getElementById('main-nav');
    const pageWrapper = document.getElementById('page-wrapper');

    if( jQuery('body.home').length){
      if (window.scrollY > 0 && window.innerWidth > 1200) {
        nav.classList.add('sticky'); // Add sticky and visible classes
      } else {
        nav.classList.remove('sticky'); // Remove classes if at the top
      }

      if(window.scrollY > vh(100) && window.innerWidth > 1200){
        nav.classList.add('visible');
      }
      else{
        nav.classList.remove('visible');
      }
    }else{
      pageWrapper.classList.add('inside-page-padding');
    }
    
  });

  // close icon when mobile toggle is clicked
// Target the navbar toggler button and the collapse menu
const navbarToggler = document.querySelector('.navbar-toggler');
const menuIcon = document.getElementById('menu-icon');
const navbarCollapse = document.getElementById('navbarNavDropdown');

// Add event listeners for Bootstrap collapse events
navbarCollapse.addEventListener('show.bs.collapse', function () {
    menuIcon.classList.remove('fa-bars');
    menuIcon.classList.add('fa-times');  // Change to close icon when menu opens
});

navbarCollapse.addEventListener('hide.bs.collapse', function () {
    menuIcon.classList.remove('fa-times');
    menuIcon.classList.add('fa-bars');  // Change to bars icon when menu closes
});

function vh(percent) {
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  return (percent * h) / 100;
}

document.addEventListener('DOMContentLoaded', function() {
  const mainNav = document.getElementById('main-nav');
  const logo = document.getElementById('logo');
  const pageWrapper = document.getElementById('page-wrapper');

  if( !jQuery('body.home').length ){
    pageWrapper.classList.add('inside-page-padding');
    mainNav.classList.add('inside-page-nav');
  }

  if(jQuery('body.home').length && window.innerWidth < 1200){
    mainNav.classList.add('position-fixed');
    //pageWrapper.classList.add('inside-page-padding');
  }
//Smooth scroll 
  // Only run this script on the homepage with the transparent-header class
  if (mainNav.classList.contains('transparent-header')) {
      const homeLogo = logoData.homeLogo;
      const scrollLogo = logoData.scrollLogo;

      function updateLogo() {
          // Check if the screen width is less than 1200px
          if (window.innerWidth < 1200) {
              // For mobile screens: remove transparent header and use scroll logo
              mainNav.classList.remove('transparent-header'); // Remove transparent header on mobile
              logo.src = scrollLogo; // Always use scroll logo on mobile
          } else {
              // For screens 1200px and above (desktop)
              if (window.scrollY > vh(100)) {
                  // Apply sticky style on scroll with scroll logo
                  if( jQuery('body.home').length ){
                    // Do stuff
                    mainNav.classList.add('sticky');
                    mainNav.classList.remove('transparent-header');
                    pageWrapper.classList.add('no-menu-padding');
                    logo.src = scrollLogo;
                  }
                 
              } else {
                  // At the top of the page, revert to transparent header and home logo
                  if( jQuery('body.home').length ){
                    mainNav.classList.remove('sticky');
                    mainNav.classList.add('transparent-header');
                    pageWrapper.classList.remove('no-menu-padding');
                    logo.src = homeLogo;
                  }
              }
          }
      }

      // Initial logo setup
      updateLogo();

      // Update logo on scroll
      window.addEventListener('scroll', updateLogo);

      // Update logo on window resize
      window.addEventListener('resize', updateLogo);
  }
});

window.addEventListener('resize', function() {
  console.log('wndow resize');
  const mainNav = document.getElementById('main-nav');
  const pageWrapper = document.getElementById('page-wrapper');
  if(jQuery('body.home').length && window.innerWidth < 1200){
    mainNav.classList.add('position-fixed');
    pageWrapper.classList.add('inside-page-padding');
  }else{
    mainNav.classList.remove('position-fixed');
  }
});
